<template>
  <v-row justify="center">
    <v-dialog v-model="infoAiModel" scrollable persistent max-width="400px">
      <v-card class="mx-auto" max-width="400">
        <v-card-title>Ai model V1 for fast costing</v-card-title>
        <v-divider></v-divider>
        <!-- {{ data }} -->
        <v-row justify="center" v-if="loading == true">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-row>
        <v-list v-else>
          <v-list-item>
            <v-list-item-title>Service name</v-list-item-title>

            <v-list-item-subtitle class="text-right">
              Price Model
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              Service cost
            </v-list-item-subtitle>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-title>total cost</v-list-item-title>
            <v-list-item-subtitle class="text-right text-h3">
              {{ data.totalCost }} {{ data.details.en_currency }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right"> </v-list-item-subtitle>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-title>base Cost</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{ data.baseCost }} {{ data.details.en_currency }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.details.cityBaseCosts }} {{ data.details.en_currency }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>weight Cost</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{ data.weightCost }} {{ data.details.en_currency }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.details.weight }} {{ data.details.en_currency }}/kg
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>distance Cost</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{ data.distanceCost }} {{ data.details.en_currency }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.distance }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>express Fee Cost</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{ data.expressFee }} {{ data.details.en_currency }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.details.expressServiceFee }}
              {{ data.details.en_currency }}
            </v-list-item-subtitle> </v-list-item
          ><v-list-item>
            <v-list-item-title>tax Fee Cost</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{ data.tax }} {{ data.details.en_currency }}
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.details.taxRate }}%
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="close">
            {{ $t("btn.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ["infoAiModel", "data", "loading"],
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close-dialog");
    },
  },
};
</script>
